import Vue from "vue";

function readAdmin() {
  try { return JSON.parse(window.localStorage.getItem("admin_user") || "{}") || {}; } catch (error) { return {}; }
}

const state = Vue.observable({ admin: readAdmin() });

export const adminStore = {
  state,
  get admin() { return state.admin; },
  setAdmin(admin) {
    state.admin = admin || {};
    window.localStorage.setItem("admin_user", JSON.stringify(state.admin));
  },
  clear() {
    state.admin = {};
    window.localStorage.removeItem("admin_user");
  }
};

export default adminStore;
